module.exports = __webpack_public_path__ + "img/spawner-die-mask-01.78accdf2.png";